/* HFB-063-AB */
(function () {
  function applyArm(arm) {
    if (arm !== 'var-1' && arm !== 'var-2') return;
    var cls = 'HFB-063-AB--' + arm;
    document.documentElement.classList.add(cls);
    if (document.body) document.body.classList.add(cls);
    else {
      document.addEventListener('DOMContentLoaded', function () {
        document.body.classList.add(cls);
      });
    }
  }

  try {
    var params = new URLSearchParams(window.location.search);
    applyArm(params.get('hfb063'));
  } catch (e) {}
})();
